export const getImageSrc = ({ document, thumbnail }) =>
  thumbnail && thumbnail.length ? thumbnail[0].image.thumbnail : document

const getCurrentRotation = (el) => {
  const angle = parseInt(el.style.transform.replace('rotate(', '').replace('deg)', ''))
  return isNaN(angle) ? 0 : angle
}

export const rotate = () => {
  const image = document.querySelectorAll('.image-gallery-slide.center img')[0]
  if (image) {
    let rotation = getCurrentRotation(image) - 90
    image.style.transform = `rotate(${rotation}deg)`
    image.style.transition = 'all 0.5s ease'
  }
}

export const resetRotate = () => {
  const image = document.querySelectorAll('.image-gallery-slide.center img')[0]
  if (image) {
    image.style.transform = ''
    image.style.transition = ''
  }
}
